import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import {
	getValue,
	tokenKey,
	usernameKey,
	userIdkey,
	userIsRoot
} from '../utils/storage'
Vue.use(Vuex)
const state = {
	user: {
		token: getValue(tokenKey),
		username: getValue(usernameKey),
		userId: getValue(userIdkey),
		isRoot: getValue(userIsRoot)
	},
	routePath: ''
}
export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})
